import * as XLSX from 'xlsx';

export interface ExportColumnDefinition {
  key: string;
  width?: number;
}

export abstract class Exporter<T> {
  protected abstract getColumnsToExport(): Array<ExportColumnDefinition>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected abstract formatData(data: T[]): Record<string, any>[];

  public generateWorkbook(data: T[]): XLSX.WorkBook {
    const columns = this.getColumnsToExport();
    const rows = this.formatData(data);

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const wscols = columns.map((col) => ({ wch: col.width }));

    if (worksheet) {
      worksheet['!cols'] = wscols;
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    return workbook;
  }

  public export(data: T[], filename: string): void {
    const workbook = this.generateWorkbook(data);
    XLSX.writeFile(workbook, filename, { bookType: 'xls' });
  }

  public generateTimestampFilename(prefix: string): string {
    const date = new Date();
    const dateStr = date.toISOString().split('T')[0];
    const timestamp = date.toISOString().split('T')[1].split('.')[0].replace(/:/g, '-');
    return `${prefix}-${dateStr}-${timestamp}.xls`;
  }
}
